import { render, staticRenderFns } from "./default.vue?vue&type=template&id=0eae5b81"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Navigation: require('/home/runner/work/marketing/marketing/components/Navigation.vue').default,Cookies: require('/home/runner/work/marketing/marketing/components/Cookies.vue').default,Footer: require('/home/runner/work/marketing/marketing/components/Footer.vue').default})
